module.exports = __webpack_public_path__ + "static/media/elements_line_start_vertical_red_50.89d66517.svg";